export default __webpack_public_path__ + "static/media/shape-rotate.34a16585.svg";